const DELAY_TIMEOUT_MS = 500;
const requestIdleCallback = window.requestIdleCallback || function (callback) {
  const start = Date.now();
  const timeRemaining = () => Math.max(0, 50 - (Date.now() - start));
  return window.setTimeout(() => callback({
    didTimeout: false,
    timeRemaining
  }), DELAY_TIMEOUT_MS);
};
const cancelIdleCallback = window.cancelIdleCallback || function (timerId) {
  window.clearTimeout(timerId);
};
export function scheduleIdleCallback(callback) {
  const id = requestIdleCallback(callback);
  return () => cancelIdleCallback(id);
}
export function debounceToIdleCallback(callback) {
  return (...args) => scheduleIdleCallback(() => {
    callback(...args);
  });
}